// extracted by mini-css-extract-plugin
export default {"customHeaders":"LanguageConfirmation_customHeaders__CkxZ2","insetBlock":"LanguageConfirmation_insetBlock__G-glY"};